import { useAtom } from '@reatom/npm-react'
import styled, { css } from 'styled-components'

import { WalletAssetListItem } from '@root/entities/wallet/ui/wallet-asset/mobile/wallet-asset-list-item'
import { useAppRoutes } from '@root/features/routing'
import { FadeOverflow, InfoMessage } from '@root/shared/ui-kit'

import type { WalletAssetsModel } from '../../atoms/reatom-wallet-assets'
import type { ClassNameProps } from '@root/shared/react'

type WalletAssetsListProps = {
  model: WalletAssetsModel
} & ClassNameProps

export const WalletAssetsList: React.FC<WalletAssetsListProps> = ({
  className,
  model,
}) => {
  const [assets] = useAtom(model.assets)
  const { navigateToTrading } = useAppRoutes()

  const renderContent = () => {
    if (assets.length > 0) {
      return (
        <AssetsList mode="always" variant="vertical">
          {assets.map((asset) => {
            const { pairAddress } = asset
            const handleClick = pairAddress
              ? () => {
                  navigateToTrading(pairAddress, asset.currency.network)
                }
              : undefined
            return (
              <WalletAssetListItem
                asset={asset}
                key={asset.currency.address}
                onClick={handleClick}
              />
            )
          })}
        </AssetsList>
      )
    }

    return (
      <AssetsList $empty={true}>
        <InfoMessage intent="empty" />
      </AssetsList>
    )
  }

  return <Root className={className}>{renderContent()}</Root>
}

const Root = styled.div`
  display: grid;
  grid-template-rows: minmax(0, 1fr);
`

const AssetsList = styled(FadeOverflow)<{ $empty?: boolean }>`
  display: grid;
  padding-top: 10px;
  align-content: start;
  overflow-y: auto;
  padding-bottom: 100px;

  ${({ $empty }) =>
    $empty &&
    css`
      align-content: center;
    `}
`
